<template>
    <div>
        <div class="simple-row">
            <div class="right">
                <button @click="exportPdf" class="swb-btn-small swb-btn">导出pdf</button>
            </div>
        </div>
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">工单信息</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>基本信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单编号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.no}}</span>
                            <el-tag v-if="servcWorkVoucher.comnRepairFlag && !servcWorkVoucher.deviceFlag" type="success">日常维修</el-tag>
                            <el-tag v-if="servcWorkVoucher.servcType != null" type="success">
                                <span>{{workServcTypeMap[servcWorkVoucher.servcType]}}</span>
                            </el-tag>
                            <el-tag v-if="servcWorkVoucher.remoted" type="success">远程解决</el-tag>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>是否委托</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-danger" v-if="servcWorkVoucher.dlgtFlag">委托</span>
                            <span class="swb-tags" v-else>否 </span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>是否委托</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-danger" v-if="servcWorkVoucher.dlgtFlag">委托</span>
                            <span class="swb-tags" v-else>否 </span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单来源</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.srcFlag != 0">{{servcWorkSrcFlagMap[servcWorkVoucher.srcFlag]}}</span>
                            <span v-else>无</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row" v-if="servcWorkVoucher.dlgtFlag">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>约检完成</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.servcType == inspectValue && servcWorkVoucher.dlgtInspectFinished">约检完成</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>约检完成时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.servcType == inspectValue && servcWorkVoucher.dlgtInspectFinishTime != null">{{servcWorkVoucher.dlgtInspectFinishTime}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>约保完成</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="(servcWorkVoucher.servcType == maintValue || servcWorkVoucher.dlgtInspectFinished) && servcWorkVoucher.dlgtMaintFinished">约保完成</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>约保完成时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success"
                                  v-if="(servcWorkVoucher.servcType == maintValue || servcWorkVoucher.dlgtInspectFinished) && servcWorkVoucher.dlgtMaintFinishTime != null">{{servcWorkVoucher.dlgtMaintFinishTime}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>交易单号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.tradeNo || ''}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>维修部件</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.devcPartName || ''}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>紧急状态</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span v-if="servcWorkVoucher.emgLevel == 0" class="font-green mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</span>
                            <span v-if="servcWorkVoucher.emgLevel == 1" class="font-orange mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</span>
                            <span v-if="servcWorkVoucher.emgLevel == 2" class="font-red mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单模式</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.grabFlag && servcWorkVoucher.grabIssuerType == 3 ? '抢单' : '指派'}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单状态</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label class="mr20 font-red" v-if="servcWorkVoucher.closed">已关闭</label>
                            <label class="mr20 font-red" v-else-if="servcWorkVoucher.invalid">已作废</label>
                            <label class="mr20 font-red" v-else-if="servcWorkVoucher.grabFlag && servcWorkVoucher.grabIssuerType == 3 && servcWorkVoucher.engineerId == null">抢单中</label>
                            <label class="mr20" v-else>{{servcWorkVoucher.stateText}}</label>
                            <label v-if="servcWorkVoucher.stateText == '服务暂停'" class="font-red">,原因：{{servcWorkVoucher.stateDesc}}</label>
                            <el-tag v-if="servcWorkVoucher.evalFlag" type="success">已评价</el-tag>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求单编号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.reqVoucherNo}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.requestTime}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单截止时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.yqFinishTime}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单创建时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.createTime}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>工单创建人</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.creatorName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>指派网点</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label v-if="servcWorkVoucher.servicerShopId == null">未指派</label>
                            <label v-else>{{servcWorkVoucher.manualShopFlag ? '手工' : '自动'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>指派工程师</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label v-if="servcWorkVoucher.engineerId == null">未指派</label>
                            <label v-else>{{servcWorkVoucher.manualEngFlag ? '手工' : '自动'}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>是否约定期保外</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <el-tag v-if="servcWorkVoucher.beyondWrnt" type="danger">交易约定外</el-tag>
                            <el-tag type="success" v-else>交易约定内</el-tag>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>仅报修人验收</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span v-if="servcWorkVoucher.acceptByRequester">是</span>
                            <span v-if="!servcWorkVoucher.acceptByRequester">否</span>
                        </div>
                    </div>
                </td>
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>业务标签</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span v-if="servcWorkVoucher.hasTag" v-for="tagName in servcWorkVoucher.tagNames">
                            <span class="swb-tags swb-tags-success mr5">{{tagName}}</span>
                        </span>
                            <span class="swb-tags swb-tags-success mr5" v-else>{{servcWorkVoucher.retailerTag}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <!-- 安装信息 -->
        <div v-if="servcWorkVoucher.servcType == 2 && servcWorkVoucher.devcSetupInfo != null && servcWorkVoucher.devcSetupInfo.devcSetupItemList != null && servcWorkVoucher.devcSetupInfo.devcSetupItemList.length > 0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">安装信息</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="devcSetupItem in servcWorkVoucher.devcSetupInfo.devcSetupItemList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备编号</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.devcXN}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>商品标识码</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.shopDeviceSvcSubNo.vendorUkno}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>卖家名称</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.shopDeviceSvcSubNo.sellerName}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>其他信息</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.extraInfo}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>含组装商品</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.asmblFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>是否组装完成</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span v-if="devcSetupItem.asmblFlag">{{devcSetupItem.asmblDone ? '是' : '否'}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>安装时完成组装</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{devcSetupItem.asmblWhileSetup ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务订单信息 -->
        <template v-if="servcWorkVoucher.servcOrderItemList != null">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">服务订单信息</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="servcOrderItem in servcWorkVoucher.servcOrderItemList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>服务名称</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcOrderItem.title}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>服务分类</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcOrderItem.catName}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>价格(元)</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcOrderItem.amount}}</span>
                    </div>
                </div>
            </div>
        </template>
        <!-- 设备信息 -->
        <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>设备信息</span>
                </td>
            </tr>
            <template v-if="servcWorkVoucher.deviceFlag">
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>系统编号</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.tmpNo || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>商品标识码</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.vendorUkno || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>设备名称</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.deviceName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>设备分类</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.deviceCatName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>维保分组</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.devcGroupFullName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>设备品牌</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.deviceBrandName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>所在部门</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.departName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>位置编码</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.devcLocCode || '无'}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <tr class="row" v-if="servcWorkVoucher.devcVendorSn != null || servcWorkVoucher.servcWorkDeviceParts != null">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>厂商序列号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label v-if="servcWorkVoucher.devcVendorSn != null">{{servcWorkVoucher.devcVendorSn || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>部件名称</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label v-for="(servcWorkDevicePart, index) in servcWorkVoucher.servcWorkDeviceParts">{{servcWorkDevicePart.partName}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <template v-if="servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length>0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">配件信息</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="servcWorkAccItem in servcWorkVoucher.servcWorkAccItemList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>配件名称</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.accName}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>个数</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.quantity}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>单位</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.unit}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>自用</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.shareAccFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>拆卸标记</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.mountFlag == 1 ? '换上' : '换下'}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>厂商序列号</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.vendorSn}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>更换信息</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>更换了{{servcWorkAccItem.replacedVendorSn}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>更换说明</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.replaceDesc}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>单价(元)</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.price}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>价格(元)</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.amount}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>要求价格下限(元)</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.accClaim.price}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>要求价格上限(元)</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkAccItem.accClaim.price2}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>要求是否满足</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span v-if="servcWorkAccItem.refAccClaimId != null && servcWorkAccItem.refAccClaimId != -1 && !servcWorkAccItem.shareAccFlag">{{servcWorkAccItem.metFlag ? '满足' : '不满足'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="servcWorkVoucher.spotImageUrl != null && servcWorkVoucher.spotImageUrl.length > 0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">现场图片</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;">
                <div style="overflow: hidden;width: 100%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <img style="width: 120px;height: 120px;" :src="servcWorkVoucher.spotImageUrl" />
                    </div>
                </div>
            </div>
        </template>

        <template v-if="servcWorkVoucher.servcWorkRepairImgFileList != null && servcWorkVoucher.servcWorkRepairImgFileList.length > 0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">{{servcWorkVoucher.servcType == 2 ? '安装' : '问题' }}图片</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;">
                <div style="overflow: hidden;width: 100%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <img style="width: 120px;height: 120px;" :src="servcWorkImgFile.fileBrowseUrl" v-for="servcWorkImgFile in servcWorkVoucher.servcWorkRepairImgFileList"/>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="servcWorkVoucher.servcWorkImgFileList != null && servcWorkVoucher.servcWorkImgFileList.length > 0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">完成图片</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;">
                <div style="overflow: hidden;width: 100%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <img style="width: 120px;height: 120px;" :src="servcWorkImgFile.fileBrowseUrl" v-for="servcWorkImgFile in servcWorkVoucher.servcWorkImgFileList"/>
                    </div>
                </div>
            </div>
        </template>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">费用信息</div>-->
        <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>费用信息 （总费用(元)：{{servcWorkVoucher.amount}}）</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>是否免费</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.freeFlag">免费</span>
                            <span class="swb-tags swb-tags-danger" v-else>收费</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>上门费(元)</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.toDoorFee == null ? '无' : servcWorkVoucher.toDoorFee}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>服务费(元)</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.generallFee == null ? '无' : servcWorkVoucher.generallFee}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>配件费(元)</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.accFee == null ? '无' : servcWorkVoucher.accFee}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">请求信息</div>-->
        <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>请求信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>服务请求方</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>业务单元</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerBizUnitName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求部门</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerShopName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求机构编号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerShopNo || ''}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求人</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.requesterStaffName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求人电话</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.requesterContactTel}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求地址</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerShopAddr}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求机构联系电话</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.buyerShopContactTel}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>请求描述</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.requestDesc || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span v-if="servcWorkVoucher.servcType == 2">安装说明</span>
                            <span v-else-if="servcWorkVoucher.servcType == 3 || servcWorkVoucher.servcType == 5">描述</span>
                            <span v-else>情况描述</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label v-if="servcWorkVoucher.troubleDesc != null">{{servcWorkVoucher.troubleDesc || '无'}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>预约上门时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.planTime || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>要求响应时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.planTime || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>要求到达时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.yqArriveTimeMi || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>要求完成时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.yqRepairedTimeMi || '无'}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>要求回询时限</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.reqTelCallTimeMi || '无'}}(分钟)</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>计划出发时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.planStartOffTime || '无'}}(分钟)</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>预计完成时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.estiFinishTime || '无'}}(分钟)</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>实际响应时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.rspTimeMi == null ? '无' : servcWorkVoucher.rspTimeMi}}(分钟)</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>实际到达时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.arriveTimeMi == null ? '无' : servcWorkVoucher.arriveTimeMi}}(分钟)</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>实际完成时长</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.repairedTimeMi == null ? '无' : servcWorkVoucher.repairedTimeMi}}(分钟)</span>
                        </div>
                    </div>
                </td>
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>实际回询时限</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.rspTelCallTimeMi == null ? '无' : servcWorkVoucher.rspTelCallTimeMi}}(分钟)</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">服务网点信息</div>-->
        <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>服务网点信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>服务商名称</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.servicerName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>服务网点名称</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.servicerShopName}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>网点联系电话</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.servicerShopContractTel}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>网点联系人</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.servicerShopContractName || ''}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">工程师信息</div>-->
        <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>工程师信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>主工程师</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.engineerName || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>辅助工程师</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.engineerNames || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>主工程师联系电话</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.contactTel || '无'}}</label>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>到达时间</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <label>{{servcWorkVoucher.toDoorTime || ''}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">合同信息</div>-->
        <template v-if="servcWorkVoucher.contractId != null">
            <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <tbody class="body">
                <tr class="row">
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>合同信息</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>合同号</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.contractNo || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>原始合同号</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.contractOriginalNo || '无'}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>

        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">交易信息</div>-->
        <template v-if="servcWorkVoucher.tradeId != null">
            <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <tbody class="body">
                <tr class="row">
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>交易信息</span>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交易单号</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.tradeNo || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交易类型</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{tradeTypeMap[servcWorkVoucher.tradeType]}}</label>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>指标跟踪阶段</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.trackPhaseName || ''}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <!--<div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">工单处理信息</div>-->
        <template v-if="servcWorkVoucher.finished">
            <table class="simple-tbl mt10" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <tbody class="body">
                <tr class="row">
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>工单处理信息</span>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>故障类型</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.faultTypeName || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>故障描述</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.faultDesc || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>维修类型</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.repairTypeName || ''}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>服务完成时间</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.finishTime || '无'}}</label>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>处理结果</span>
                            </div>
                            <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                                <label>{{servcWorkVoucher.handleResult || '无'}}</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <!--工单操作记录-->
        <template v-if="servcWorkVoucherRecList != null &&　servcWorkVoucherRecList.length>0">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">工单操作记录</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="servcWorkVoucherRec in servcWorkVoucherRecList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作人</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.actorName}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作人</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.action}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作人身份</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.actRole}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>附加信息</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.extraInfo}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作位置</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.loc}}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作时间</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{servcWorkVoucherRec.ts}}</span>
                    </div>
                </div>
            </div>
        </template>

        <!-- 凭单信息 -->
        <template v-if="servcWorkVoucher.finished && (servcWorkVoucher.servcType == 0 || servcWorkVoucher.servcType == 1 || servcWorkVoucher.additionFlag)">
            <swb-servc-work-add-item-list :id="voucherId" ref="swb_servc_work_add_item_list"></swb-servc-work-add-item-list>
        </template>
        <template v-if="servcWorkVoucher.devcInspectFlag && servcWorkVoucher.devcInspectInfo != null">
            <div class="order-tmp-caption" style="font-size: 15px;color: #1a1a1a;font-weight: 600;text-align: center;padding: 15px 0;">检验签字信息</div>
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
                <tbody class="body">
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交出接收人</span>
                            </div>
                            <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkVoucher.devcInspectInfo.handoverOutRcvName}}</span>
                            </div>
                        </div>
                        <div class="sign-name" style="height: 160px;text-align: center;">
                            <img style="height: 160px;" :src=" servcWorkVoucher.devcInspectInfo.handoverOutRcvSigUrl"/>
                        </div>
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>检验日期</span>
                            </div>
                            <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span>{{new Date(servcWorkVoucher.devcInspectInfo.inspectDate).format("yyyy年MM月dd日")}}</span>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交回接收人</span>
                            </div>
                            <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkVoucher.devcInspectInfo.handoverInRcvName}}</span>
                            </div>
                        </div>
                        <div class="sign-name" style="height: 160px;text-align: center;">
                            <img style="height: 160px;" :src=" servcWorkVoucher.devcInspectInfo.handoverInRcvSigUrl"/>
                        </div>
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>检验日期</span>
                            </div>
                            <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span v-if="servcWorkVoucher.devcInspectInfo.inspectDate != null">{{new Date(servcWorkVoucher.devcInspectInfo.inspectDate).format("yyyy年MM月dd日")}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-if="servcWorkVoucher.devcMaintFlag">
            <swb-servc-work-devc-maint-voucher-list :id="voucherId" ref="swb_servc_work_devc_maint_voucher_list"></swb-servc-work-devc-maint-voucher-list>
        </template>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import {showHtmlToPdfDlg} from '../ctrl/dialog'

    import servcDelivApi from '../../api/servcDeliv'

    import SwbServcWorkAddItem from './ServcWorkAddItem';
    Vue.regist(SwbServcWorkAddItem);
    //
    import SwbDevcMaintVoucherPdf from './DevcMaintVoucherPdf'
    Vue.regist(SwbDevcMaintVoucherPdf);
    import SwbCheckWorkVoucherPdf from './CheckWorkVoucherPdf'
    Vue.regist(SwbCheckWorkVoucherPdf);

    export default {
        name: 'swb-servc-work-voucher-pdf',
        desc: '服务工单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            }
        },
        data: function () {
            return {
                servcWorkVoucher: {},
                servcWorkVoucherRecList: [],
                //
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                tradeTypeMap: getEnumMap('tradeType', 'value2text'),
                workServcTypeMap: getEnumMap('workServcType', 'value2text'),
                servcWorkSrcFlagMap: getEnumMap("servcWorkSrcFlag", "value2text"),
                inspectValue: getEnumInfoWith('workServcType', 'name', 'DetectionAnalyze').value,
                maintValue: getEnumInfoWith('workServcType', 'name', 'ProductMaint').value,
            }
        },
        created: function () {
            this.getServcWorkVoucher();
        },
        methods: {
            getServcWorkVoucher: function () {
                let self = this;
                let params = {
                    id: this.voucherId
                };
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let servcWorkVoucher = result.data || {};
                        //
                        if (servcWorkVoucher.closed) {
                            servcWorkVoucher.stateText = '已关闭';
                        } else if (servcWorkVoucher.invalid) {
                            servcWorkVoucher.stateText = '已作废';
                        } else {
                            let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                            if (stateInfo != null) {
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        //
                        let engineerNameStr = servcWorkVoucher.engineerNames;
                        let engineerName = servcWorkVoucher.engineerName;
                        if (!Utils.isNoB(engineerNameStr)) {
                            let nameStr = null;
                            let engineerNames = engineerNameStr.split("、");
                            for (let i = 0; i < engineerNames.length; i++) {
                                let name = engineerNames[i];
                                if (name != engineerName) {
                                    if (nameStr == null) {
                                        nameStr = name;
                                    } else if (nameStr.indexOf(name) < 0) {
                                        nameStr = nameStr + '、' + name;
                                    }
                                }
                            }
                            servcWorkVoucher.engineerNames = nameStr;
                        }
                        //
                        if (!Utils.isNoB(servcWorkVoucher.retailerTag)) {
                            let retailerTag = servcWorkVoucher.retailerTag;
                            let tagIdList = [];
                            if (!Utils.isNoB(retailerTag)) {
                                if (retailerTag.indexOf("|") >= 0) {
                                    servcWorkVoucher.hasTag = true;
                                    retailerTag = retailerTag.substring(1, retailerTag.length - 1);
                                    tagIdList = retailerTag.split("|") || [];
                                } else {
                                    servcWorkVoucher.hasTag = false;
                                }
                            }
                            let tagNames = [];
                            for (let i = 0; i < tagIdList.length; i++) {
                                let tagId = parseInt(tagIdList[i]);
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if (tagName != null) {
                                    tagNames.push(tagName);
                                }
                            }
                            servcWorkVoucher.tagNames = tagNames;
                        }
                        self.servcWorkVoucher = servcWorkVoucher;
                        //
                        self.getServcWorkVoucherRecList(servcWorkVoucher.id);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getServcWorkVoucherRecList: function (voucherId) {
                let self = this;
                let params = {};
                params.workVoucherId = voucherId;
                servcDelivApi.getServcWorkVoucherRecListByWorkVoucherId(params, function (result) {
                    if (result.type === "info") {
                        self.servcWorkVoucherRecList = result.data;
                    }
                });
            },
            //
            exportPdf: function () {
                let result = this.$el.outerHTML;
                //
                showHtmlToPdfDlg("服务工单导出", result, null);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherPdf.vue